import Modal from '@/components/modal/Modal'
import React, { useState } from 'react'

import { PreviewModal, PreviewTitle } from '../styles/ProductDetail.style'
import { IProduct } from 'src/api/product'
import { useModal } from 'src/utils/overlay'
import getPreviewImage from '../utils/getPreviewImage'

interface ProductPreviewModalProps {
	product: IProduct
}

const ProductPreviewModal: React.FC<ProductPreviewModalProps> = (props) => {
	const { product } = props
	const previewImages = getPreviewImage(product)
	const totalPage = previewImages.length + 1

	const [defaultImage, setDefaultImage] = useState({ url: product.thumb_img, page: 1 })
	const [isPreviewOpen, { close: closePreviewModal }] = useModal('preview-modal')
	return (
		<Modal
			depth={1}
			onClose={closePreviewModal}
			open={isPreviewOpen}
			title={
				<PreviewTitle>
					{product.title} 미리보기{' '}
					<span>
						{defaultImage.page}/{totalPage}
					</span>
				</PreviewTitle>
			}
			name="preview">
			<PreviewModal>
				<div className={'navigator'}>
					<div>
						<button
							className={defaultImage.url === product.thumb_img ? 'active' : ''}
							onClick={() =>
								setDefaultImage({
									url: product.thumb_img,
									page: 1,
								})
							}
							style={{ backgroundImage: `url(${product.thumb_img})` }}
						/>
						<>
							{previewImages.map((item, index) => {
								return (
									<button
										className={defaultImage.url === item.url ? 'active' : ''}
										key={'preview-image' + index}
										onClick={() =>
											setDefaultImage({
												url: item.url,
												page: index + 2,
											})
										}
										style={{
											backgroundImage: `url(${item.url})`,
										}}
									/>
								)
							})}
						</>
					</div>
				</div>
				<div className={'zoom'}>
					<div
						className={'zoom-image'}
						style={{ backgroundImage: `url(${defaultImage.url})` }}
					/>
				</div>
			</PreviewModal>
		</Modal>
	)
}

export default ProductPreviewModal
